export enum KbaProductType {
  DISCOVERY = 'Discovery',
  IIDQA = 'IIDQA'
}
